import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ApiFetch, CreateAsyncStatusHandler, ResetSliceState } from "../../../app/SliceUtils";

export const fetchInformationArticles = createAsyncThunk(
    '/api/informationManagement/get',
    (args, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/informationManagement`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const fetchInformationArticle = createAsyncThunk(
    '/api/informationManagement/informationArticleId',
    (informationArticleId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/informationManagement/${informationArticleId}`, contentType: 'application/x-www-form-urlencoded' }, rejectWithValue)
);

export const postInformationArticle = createAsyncThunk(
    '/api/informationManagement/post',
    (newInformationArticle, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/informationManagement`, method: 'POST', body: newInformationArticle }, rejectWithValue)
);

export const putInformationArticle = createAsyncThunk(
    '/api/informationManagement/put',
    (updatedInformationArticle, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/informationManagement`, method: 'PUT', body: updatedInformationArticle }, rejectWithValue)
);

export const deleteInformationArticle = createAsyncThunk(
    '/api/informationManagement/delete/informationArticleId',
    (informationArticleId, { rejectWithValue }) =>
        ApiFetch({ endpoint: `api/informationManagement/${informationArticleId}`, method: 'DELETE' }, rejectWithValue)
);

export const informationManagementSlice = createSlice({
    name: 'informationManagement',
    initialState: {
        informationArticles: { data: null, status: null },
        informationArticle: { data: null, status: null },
        informationArticlePost: { data: null, status: null },
        informationArticlePut: { data: null, status: null },
        informationArticleDelete: { data: null, status: null },
    },
    reducers: {
        resetInformationArticle: (state) => {
            ResetSliceState(state, [
                'informationArticle'
            ]);
        },
        resetInformationArticleManagementStatus: (state) => {
            ResetSliceState(state, [
                'informationArticlePost',
                'informationArticlePut',
                'informationArticleDelete'
            ]);
        },
    },
    extraReducers: (builder) => {
        CreateAsyncStatusHandler(builder, fetchInformationArticles, 'informationArticles');
        CreateAsyncStatusHandler(builder, fetchInformationArticle, 'informationArticle');
        CreateAsyncStatusHandler(builder, postInformationArticle, 'informationArticlePost');
        CreateAsyncStatusHandler(builder, putInformationArticle, 'informationArticlePut');
        CreateAsyncStatusHandler(builder, deleteInformationArticle, 'informationArticleDelete');
    }
});

export const {
    resetInformationArticle,
    resetInformationArticleManagementStatus
} = informationManagementSlice.actions;

export default informationManagementSlice.reducer;